export const SETTINGS = 'SETTINGS';
